import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { useLocation } from 'react-router-dom';
import ShareImgBtn from '../ShareSNS/ShareImgBtn';
import ShareKakaoBtn from '../ShareSNS/ShareKakaoBtn';
import ShareLinkBtn from '../ShareSNS/ShareLinkBtn';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import workdata from '../common/API/WorkAPI.json';
import romancedata from '../common/API/RomanceAPI.json';
import funnydata from '../common/API/FunnyAPI.json';
import devdata from '../common/API/DevAPI.json';
import fooddata from '../common/API/FoodAPI.json';
import covertdata from '../common/API/CovertAPI.json';
import axios from 'axios';
import KakaoAdfit1 from '../KakaoAdfit/KakaoAdfit1';
import KakaoAdfit2 from '../KakaoAdfit/KakaoAdfit2';
import KakaoAdfit3 from '../KakaoAdfit/KakaoAdfit3';
import KakaoAdfit4 from '../KakaoAdfit/KakaoAdfit4';
import { isMobile } from '../common/style';

type Data = {
  id: number;
  select: string;
  answers: { type: string; answer: string }[];
};

const SelectPage: React.FC = () => {
  const [num, setNum] = useState(0);
  const [data, setData] = useState<Data[]>();
  const [percent, setPercent] = useState({ left: 0, right: 0 });
  const [show, setShow] = useState(false);
  const [divshow, setDivShow] = useState(false);
  const location = useLocation();
  const array = location.state.array;
  const select = location.state.select;
  const [isdisabled, setIsDisabled] = useState({
    left: true,
    right: false,
  });
  const [selectdisabled, setSelectDisabled] = useState({
    left: false,
    right: false,
  });
  const [selectdiv, setSelectDiv] = useState({
    left: false,
    right: false,
  });

  useEffect(() => {
    if (select === 'work') {
      setData(workdata);
    } else if (select === 'romance') {
      setData(romancedata);
    } else if (select === 'funny') {
      setData(funnydata);
    } else if (select === 'food') {
      setData(fooddata);
    } else if (select === 'dev') {
      setData(devdata);
    } else if (select === 'covert') {
      setData(covertdata);
    }
  }, [select]);

  const PrevClick = () => {
    setDivShow(false);
    setShow(false);
    setSelectDisabled((prevDisabled) => ({
      ...prevDisabled,
      left: false,
      right: false,
    }));
    setSelectDiv((prevSelectDiv) => ({
      ...prevSelectDiv,
      left: false,
      right: false,
    }));
    if (num !== 0) {
      setIsDisabled((prevDisabled) => ({
        ...prevDisabled,
        right: false,
      }));
      setNum(num - 1);
    }
    if (num === 1) {
      setIsDisabled((prevDisabled) => ({
        ...prevDisabled,
        left: true,
      }));
      setNum(num - 1);
    }
  };

  const nextClick = () => {
    setDivShow(false);
    setShow(false);
    setSelectDisabled((prevDisabled) => ({
      ...prevDisabled,
      left: false,
      right: false,
    }));
    setSelectDiv((prevSelectDiv) => ({
      ...prevSelectDiv,
      left: false,
      right: false,
    }));
    if (data !== undefined) {
      if (num !== data.length - 1) {
        setIsDisabled((prevDisabled) => ({
          ...prevDisabled,
          left: false,
        }));
        setNum(num + 1);
      }
      if (num === data.length - 2) {
        setIsDisabled((prevDisabled) => ({
          ...prevDisabled,
          right: true,
        }));
        setNum(num + 1);
      }
    }
  };

  const LeftClick = async (id: number) => {
    setDivShow(true);
    let leftselectid = 0;
    let rightselectid = 0;

    setSelectDisabled((prevDisabled) => ({
      ...prevDisabled,
      left: true,
      right: true,
    }));

    setSelectDiv((prevSelectDiv) => ({
      ...prevSelectDiv,
      left: true,
      right: false,
    }));

    try {
      const response = await axios.get(
        `https://balancegame-34cd5-default-rtdb.firebaseio.com/${select}/${id}.json`,
      );
      const responseData = response.data;

      if (
        responseData &&
        responseData.left !== undefined &&
        responseData.right !== undefined
      ) {
        leftselectid = responseData.left;
        rightselectid = responseData.right;
      }
    } catch (error) {
      console.error(error);
    }

    try {
      await axios.put(
        `https://balancegame-34cd5-default-rtdb.firebaseio.com/${select}/${id}.json`,
        {
          left: Number(leftselectid) + 1,
          right: Number(rightselectid),
        },
      );
    } catch (error) {
      console.error(error);
    }

    try {
      const response = await axios.get(
        `https://balancegame-34cd5-default-rtdb.firebaseio.com/${select}/${id}.json`,
      );
      const responseData = response.data;
      leftselectid = responseData.left;
      rightselectid = responseData.right;
      setPercent((prevPercent) => ({
        ...prevPercent,
        left: leftselectid,
        right: rightselectid,
      }));
    } catch (error) {
      console.error(error);
    }
    setShow(true);
  };

  const RightClick = async (id: number) => {
    setDivShow(true);
    let leftselectid = 0;
    let rightselectid = 0;

    setSelectDisabled((prevDisabled) => ({
      ...prevDisabled,
      left: true,
      right: true,
    }));

    setSelectDiv((prevSelectDiv) => ({
      ...prevSelectDiv,
      left: false,
      right: true,
    }));

    try {
      const response = await axios.get(
        `https://balancegame-34cd5-default-rtdb.firebaseio.com/${select}/${id}.json`,
      );
      const responseData = response.data;
      if (
        responseData &&
        responseData.left !== undefined &&
        responseData.right !== undefined
      ) {
        leftselectid = responseData.left;
        rightselectid = responseData.right;
      }
    } catch (error) {
      console.error(error);
    }

    try {
      await axios.put(
        `https://balancegame-34cd5-default-rtdb.firebaseio.com/${select}/${id}.json`,
        {
          left: Number(leftselectid),
          right: Number(rightselectid) + 1,
        },
      );
    } catch (error) {
      console.error(error);
    }

    try {
      const response = await axios.get(
        `https://balancegame-34cd5-default-rtdb.firebaseio.com/${select}/${id}.json`,
      );
      const responseData = response.data;
      leftselectid = responseData.left;
      rightselectid = responseData.right;
      setPercent((prevPercent) => ({
        ...prevPercent,
        left: leftselectid,
        right: rightselectid,
      }));
    } catch (error) {
      console.error(error);
    }
    setShow(true);
  };

  return (
    <Center>
      <h1>밸런스게임</h1>
      <ImgCapture id="saveImg">
        <Container>
          {data !== undefined ? (
            <h2>{data[array[num]].select}</h2>
          ) : (
            <h2>undefined</h2>
          )}
          <SelectDiv>
            <VS>VS</VS>
            <Btn disabled={isdisabled.left}>
              <FiChevronLeft className="icon" onClick={() => PrevClick()} />
            </Btn>
            <LeftDiv
              onClick={() => data && LeftClick(data[array[num]].id)}
              disabled={selectdisabled.left}
              selectdiv={selectdiv.left ? 1 : 0}
            >
              {data !== undefined ? (
                <DivH3>{data[array[num]].answers[0].answer}</DivH3>
              ) : (
                <DivH3>undefined</DivH3>
              )}
              {divshow ? (
                <Percent>
                  {show ? (
                    <h4>
                      {(
                        (percent.left / (percent.right + percent.left)) *
                        100
                      ).toFixed(0)}
                      % ({percent.left})
                    </h4>
                  ) : (
                    <></>
                  )}
                </Percent>
              ) : (
                <></>
              )}
            </LeftDiv>
            <RightDiv
              onClick={() => data && RightClick(data[array[num]].id)}
              disabled={selectdisabled.right}
              selectdiv={selectdiv.right ? 1 : 0}
            >
              {data !== undefined ? (
                <DivH3>{data[array[num]].answers[1].answer}</DivH3>
              ) : (
                <DivH3>undefined</DivH3>
              )}
              {divshow ? (
                <Percent>
                  {show ? (
                    <h4>
                      {(
                        (percent.right / (percent.right + percent.left)) *
                        100
                      ).toFixed(0)}
                      % ({percent.right})
                    </h4>
                  ) : (
                    <></>
                  )}
                </Percent>
              ) : (
                <></>
              )}
            </RightDiv>
            <Btn disabled={isdisabled.right}>
              <FiChevronRight className="icon" onClick={() => nextClick()} />
            </Btn>
          </SelectDiv>
          <h6 onClick={() => window.open('https://github.com/rlotr02')}>
            ⓒ 2023. rlotr02 All rights reserved.
          </h6>
        </Container>
      </ImgCapture>
      <ShareBtn>
        <ShareLinkBtn />
        <ShareKakaoBtn
          key={num}
          text1={data ? data[array[num]].answers[0].answer : 'undefined'}
          text2={data ? data[array[num]].answers[1].answer : 'undefined'}
        />
        <ShareImgBtn />
      </ShareBtn>
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default SelectPage;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #4da082;

    margin-top: 63px;
    margin-bottom: 10px;

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 15px;
    }
  }
`;

const ImgCapture = styled.div`
  height: 510px;
  width: 790px;
  display: flex;
  justify-content: center;

  ${isMobile} {
    width: 320px;
    height: 328px;
  }
`;

const Container = styled.div`
  margin-top: 30px;
  width: 730px;
  height: 450px;

  border-radius: 70px;
  border: 3px solid #3d6c5b;
  background: #dcf0e9;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.2);
  position: relative;
  text-align: center;

  ${isMobile} {
    border: 2px solid #3d6c5b;
    margin-top: 15px;
    width: 300px;
    height: 290px;
    border-radius: 30px;
  }

  h2 {
    color: #3e6a55;
    font-family: GmarketSansBold;
    font-size: 23px;
    font-weight: 700;
    margin: 30px 0;

    ${isMobile} {
      font-size: 17px;
      margin: 17px 0;
    }
  }

  h6 {
    color: #586f64;
    font-family: GmarketSansLight;
    font-size: 13px;
    font-weight: 300;
    margin-top: 18px;
    cursor: pointer;

    ${isMobile} {
      font-size: 10px;
      margin-top: 11px;
    }
  }
`;

const Btn = styled.button`
  border: none;
  background: transparent;

  .icon {
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    font-size: 50px;
    color: #8c9f96;

    &:hover {
      color: ${(props) => (props.disabled ? '#8c9f96' : '#566d62')};
    }

    ${isMobile} {
      font-size: 30px;
    }
  }
`;

const SelectDiv = styled.div`
  display: flex;
  justify-content: center;
`;

const VS = styled.div`
  z-index: 9999;
  position: absolute;
  font-family: GmarketSansBold;
  font-size: 20px;
  margin-top: 140px;
  color: #9a86e1;

  ${isMobile} {
    font-size: 14px;
    margin-top: 91px;
  }
`;

const LeftDiv = styled.button<{ selectdiv: number }>`
  border: none;
  width: 240px;
  height: 300px;
  background: ${(props) => (props.selectdiv ? '#f4bcbc' : '#f2d9d9')};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

  ${isMobile} {
    width: 160px;
    height: 190px;
  }

  &:hover {
    background: ${(props) => (props.disabled ? '' : '#f4bcbc')};
  }
`;

const RightDiv = styled.button<{ selectdiv: number }>`
  border: none;
  width: 240px;
  height: 300px;
  background: ${(props) => (props.selectdiv ? '#b3c9f2' : '#cadaf8')};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

  ${isMobile} {
    width: 160px;
    height: 190px;
  }

  &:hover {
    background: ${(props) => (props.disabled ? '' : '#b3c9f2')};
  }
`;

const DivH3 = styled.h3`
  color: #675050;
  text-align: center;
  font-family: GmarketSansMedium;
  font-size: 15px;
  font-weight: 500;
  padding: 0 30px;
  word-break: keep-all;

  ${isMobile} {
    font-size: 11px;
    padding: 0 5px;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Percent = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 70px;
  background: rgba(85, 79, 79, 0.4);

  opacity: 0;
  animation: ${fadeIn} 0.8s ease-in-out forwards;

  ${isMobile} {
    height: 50px;
  }

  h4 {
    color: #f0f0f0;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 700;
    margin-top: 22px;

    opacity: 0;
    animation: ${fadeIn} 0.5s ease-in-out forwards;

    ${isMobile} {
      font-size: 11px;
      margin-top: 17px;
    }
  }
`;

const ShareBtn = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;

  ${isMobile} {
    margin-bottom: 13px;
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-right: 950px;
  position: absolute;
`;

const KakaoAdfitDiv2 = styled.div`
  margin-left: 950px;
  position: absolute;
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
`;
